/** Helpers for the About-you (completeSignup) page: pure, no React. */

const PROVIDER_NAMES = {
  password: 'email',
  'google.com': 'google',
  'apple.com': 'apple',
  phone: 'phone',
  'phone.com': 'phone',
  anonymous: 'anonymous',
};

export function normalizeAuthProvider(providerId) {
  return PROVIDER_NAMES[providerId] || providerId || null;
}

export function getAuthProviderFields(user) {
  if (!user) return { authProvider: null, authProviders: [], authEmail: null };
  const providerIds = [
    ...(user.providerData || []).map((p) => p && p.providerId).filter(Boolean),
    user.providerId,
  ].filter(Boolean);
  const authProviders = Array.from(new Set(
    providerIds.map(normalizeAuthProvider).filter(Boolean),
  ));
  const priority = ['google', 'apple', 'email', 'phone', 'anonymous'];
  const authProvider = priority.find((c) => authProviders.includes(c)) || authProviders[0] || null;
  return { authProvider, authProviders, authEmail: user.email || null };
}

/** A phone-first sign-up: the auth user's only sign-in is a phone number. */
export function isPhoneOnlyAuthUser(user) {
  if (!user) return false;
  const ids = (user.providerData || []).map((p) => p && p.providerId).filter(Boolean);
  return ids.includes('phone') && !ids.some((id) => id === 'password' || id === 'google.com' || id === 'apple.com');
}

/**
 * The sign-up has a finish step only when a link brought the person here: the
 * join consent or the claim confirmation. Everything else ends at "About you".
 */
export function signupStepsTotal(redirect) {
  return /\/client\/(?:join|claim)\//.test(redirect || '') ? 3 : 2;
}
